<template>
    <div class="flex items-center justify-center h-screen px-6 bg-color-blue-gradient">
        <div class="w-full max-w-sm p-6 bg-white rounded-md shadow-md">
        <div class="flex items-center justify-center mb-10">
            <span class="text-2xl font-semibold text-gray-700">
                <img class="logo large-logo" src="@/assets/img/ceLogo2.svg" />
            </span>
        </div>
        <FormKit type="form" :actions="false" @submit="login" incomplete-message="">
            <FormKit
                type="email"
                name="email"
                v-model="user.username"
                validation="required|email"
                validation-label="Email"
                placeholder="Email"
                :validation-messages="{
                    required: 'Ce champ est requis',
                    email: 'Veuillez saisir une adresse email valide'
                }"
            />
            
            <FormKit
                type="password"
                name="password"
                v-model="user.password"
                validation="required"
                validation-label="Password"
                placeholder="Password"
                :validation-messages="{
                    required: 'Ce champ est requis'
                }"
                suffix-icon="eyeClosed"
                @suffix-icon-click="handleIconClick"
                suffix-icon-class="hover:text-blue-500"
            />
            
            <div class="flex justify-between mt-4 row">
                <FormKit
                    type="checkbox"
                    name="remember"
                    label="Se souvenir de moi"
                    class="mr-2 text-indigo-600 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                />
                <a class="block text-sm fontme hover:underline primary-color mt-1" href="https://app.club-employes.com/reset-password/">
                    Mot de passe oublié ?
                </a>
            </div>
            <div v-if="errorMessage" class="text-center text-red-500 mt-2">
                {{ errorMessage }}
            </div>
            <div class="w-full mt-4">
                <FormKit 
                    type="submit"
                    style="display: flex;
                        justify-content: center;
                        align-items: center;background-color: #041D4B;
                        border-radius: 5px;
                        border: none;
                        cursor: pointer;
                        width: 100%;
                        text-align: center;
                        "
                    label="Se connecter"
                />
            </div>
        </FormKit>
        </div>
    </div>
</template>

<script lang="ts" setup>

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth/authStore';

const router = useRouter();
const authStore = useAuthStore();
const user = ref({ username: '', password: '' });
const isConnecting = ref(false);
const errorMessage = ref('');
const login = async () => {
    isConnecting.value = true;
    errorMessage.value = '';
    try {
        const login = await authStore.login(user.value);
        if (200 === login.status) {
            await router.push({ name: 'dashboard' });
        }
        
        if (202 === login.status) {
            localStorage.setItem('userEmail', user.value.username);
            await router.push({ name: 'CheckGoogle2FaCode' });
        }
    } catch (error) {
        console.dir(error);
        errorMessage.value = 'Vos identifiants sont incorrects.';
    } finally {
        isConnecting.value = false;
    }
};
const handleIconClick = (node, e) => {
    node.props.suffixIcon = node.props.suffixIcon === 'eye' ? 'eyeClosed' : 'eye'
    node.props.type = node.props.type === 'password' ? 'text' : 'password'
}
</script>

<style scoped>
input{
    padding: 10px;
    background-color: #FFFFFF;
    color: #333333;
    border:  1px solid #999;
}
.primary-bg{
    background-color: #041D4B;
}
.color-color{
    color: #041D4B;
}
.custom-btn {
    background-color: #041D4B;
    color: #FFFFFF;
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
}
.custom-btn:hover {
    background-color: #02306D;
}
.custom-btn:disabled {
    background-color: #CCCCCC;
    cursor: not-allowed;
}
.bg-color-blue-gradient {
    background: linear-gradient(112.26deg, #275CF1 -28.65%, #0B1C48 91.24%)
}
.large-logo {
    width: 200px;
    height: auto;
}
</style>